"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDelayedState = void 0;
const react_1 = require("react");
const useDelayedState = (initial, inDelay, outDelay) => {
    const [state, setState] = react_1.useState(initial);
    const inTimer = react_1.useRef(null);
    const outTimer = react_1.useRef(null);
    const delayedSetState = (newState) => {
        if (inTimer.current) {
            clearTimeout(inTimer.current);
            inTimer.current = null;
        }
        if (outTimer.current) {
            clearTimeout(outTimer.current);
            outTimer.current = null;
        }
        if (newState) {
            inTimer.current = window.setTimeout(() => setState(newState), inDelay);
        }
        else {
            outTimer.current = window.setTimeout(() => setState(newState), outDelay);
        }
    };
    return [state, delayedSetState];
};
exports.useDelayedState = useDelayedState;
exports.default = exports.useDelayedState;
//# sourceMappingURL=useDelayedState.js.map